// extracted by mini-css-extract-plugin
export default {"title":"CasesTop5_title__2Ih-Z"};